import { DeleteAccountError, DeleteAccountErrorKind } from '@griply/types';
import { useCallback } from 'react';
import { useDeleteAccountMutation } from 'shared/hooks/queries/use-delete-account-mutation';

export type UseDeleteAccountResult = {
  submit: () => Promise<void>;
  isLoading: boolean;
  isError: boolean;
  errorKind: DeleteAccountErrorKind | null;
  reset: () => void;
};

export const useDeleteAccount = (): UseDeleteAccountResult => {
  const { mutateAsync, isPending, isError, error, reset } =
    useDeleteAccountMutation();

  const submit = useCallback(async () => {
    await mutateAsync();
  }, [mutateAsync]);

  const errorKind =
    isError && error instanceof DeleteAccountError ? error.kind : null;

  return {
    submit,
    isLoading: isPending,
    isError,
    errorKind,
    reset,
  };
};
